import styled from 'styled-components';

export const Body = styled.p`
  margin: 0;
  font-size: 0.9rem;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const PromptName = styled.strong`
  display: block;
  margin-top: 0.75rem;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
`;
